<h1>
    Invitaciones a trabajar
    <span class="badge accent">{{ invitaciones?.length }}</span>
</h1>
<mat-divider></mat-divider>

<div fxLayout="row" fxLayoutAlign="space-around center">
    <mat-spinner
        *ngIf="cargandoInvitaciones"
        color="accent"
        diameter="50"
    ></mat-spinner>
</div>
<div *ngIf="invitaciones">
    <div
        *ngIf="invitaciones.length === 0 && !cargandoInvitaciones"
        class="mt-8 message-box error"
    >
        No se han encontrado invitaciones
    </div>
    <table class="simple mt-8">
        <thead>
            <tr>
                <th>#</th>
                <th>Contratista</th>
                <th>Fecha Vigencia</th>
                <th>Estado</th>
                <th>Fecha del trabajo</th>
                <th>Valor ofertado</th>

                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr
                *ngFor="let invitacion of invitaciones; let idx = index"
                [ngClass]="{
                    'red-100-bg':
                        invitacion.estadoInvitacion.idEstadoInvitacion ===
                        config.invitacion.estados.rechazada.id,
                    'green-100-bg':
                        invitacion.estadoInvitacion.idEstadoInvitacion ===
                        config.invitacion.estados.aceptada.id,
                    'grey-100-bg':
                        invitacion.estadoInvitacion.idEstadoInvitacion ===
                            config.invitacion.estados.ofertada.id &&
                        !invitacion.vigente
                }"
            >
                <td>
                    <strong>{{ idx + 1 }}.- </strong>
                </td>

                <td
                    class="primary-fg cursor-pointer"
                    (click)="verFichaContratista(invitacion.contratista.nrRut)"
                >
                    <div
                        fxLayout="row"
                        fxLayoutAlign="start start"
                        fxLayoutGap="14px"
                    >
                        <div>
                            <!-- img
                                class="avatar-imagen-mini"
                                [src]="getFoto(invitacion.contratista.codigoFoto)"
                                [alt]="
                                    invitacion.contratista.nombres +
                                    ' ' +
                                    invitacion.contratista.apellidos
                                "
                            / -->
                        </div>

                        <div>
                            <strong
                                >{{ invitacion.contratista.nombres }}
                                {{ invitacion.contratista.apellidos }}</strong
                            >
                            <br />
                            <small> {{ invitacion.contratista.rut }}</small>
                            <br />
                            <app-star-rating
                                [seteable]="false"
                                [evaluacion]="invitacion.contratista.evaluacion"
                            ></app-star-rating>
                        </div>
                    </div>
                </td>
                <td>
                    <mat-icon
                        *ngIf="!invitacion.vigente"
                        matTooltip="Invitación vencida"
                        [matTooltipPosition]="tooltipPosition"
                        >alarm_off</mat-icon
                    >
                    <mat-icon
                        *ngIf="invitacion.vigente"
                        matTooltip="Invitación vigente"
                        [matTooltipPosition]="tooltipPosition"
                        >alarm_on</mat-icon
                    >
                    <span [ngClass]="{ 'text-strike': !invitacion.vigente }">{{
                        invitacion.fechaVigencia | date: "dd-MM-yyyy HH:mm"
                    }}</span>
                </td>
                <td>
                    <strong
                        >{{ invitacion.estadoInvitacion.descripcion }}
                    </strong>
                    <span
                        *ngIf="
                            invitacion.estadoInvitacion.idEstadoInvitacion ===
                                config.invitacion.estados.ofertada.id &&
                            !invitacion.vigente
                        "
                        >(Sin respuesta)</span
                    >
                    <br />
                    <small>
                        {{
                            invitacion.fechaEstado | date: "dd-MM-yyyy HH:mm"
                        }}</small
                    >
                </td>

                <td>
                    <mat-icon
                        matTooltip="Fecha de inicio y término de los trabajos"
                        [matTooltipPosition]="tooltipPosition"
                        >date_range</mat-icon
                    >
                    <strong>{{
                        invitacion.fechaInicioSolicitada | date: "dd-MM-yyyy"
                    }}</strong>
                    al
                    <br />

                    <strong>{{
                        invitacion.fechaTerminoSolicitada | date: "dd-MM-yyyy"
                    }}</strong>
                </td>
                <td>
                    {{
                        invitacion.totalOfertado
                            | currency: "CLP":"symbol-narrow"
                            | monto
                    }}
                    <!--<br />
                    <span *ngIf="invitacion.incluyeMateriales">
                        <mat-icon
                            matTooltip="Incluye materiales"
                            [matTooltipPosition]="tooltipPosition"
                            >playlist_add</mat-icon
                        ></span
                    >-->
                </td>

                <td>
                    <button
                        mat-button
                        color="accent"
                        (click)="asignarContratista(invitacion)"
                        *ngIf="
                            invitacion.estadoInvitacion.idEstadoInvitacion ===
                                config.invitacion.estados.aceptada.id &&
                            puedeAsignar
                        "
                    >
                        Asignar
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
